module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-drizzle-fill-ec2dcfd8.svg";